"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudToDevice = exports.CloudToDeviceEnvelope = exports.DeviceToCloud = exports.C2DMessage = exports.D2CMessage = exports.PrefsC2DMessage = exports.PrefsD2CMessage = exports.ConsumableC2DMessage = exports.ConsumableD2CMessage = exports.TelemetryC2DMessage = exports.TelemetryMessage = exports.SystemC2DMessage = exports.StateC2DMessage = exports.StateMessage = exports.EventMessage = exports.AlarmMessage = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const gbfc_1 = require("../../../device/class/gbfc");
const common_1 = require("../../common");
const Alarm = __importStar(require("../alarm"));
const Consumable = __importStar(require("../consumable"));
const Event = __importStar(require("../event"));
const Prefs = __importStar(require("../prefs"));
const State = __importStar(require("../state"));
const System = __importStar(require("../system"));
const Telemetry = __importStar(require("../telemetry"));
exports.NAMESPACE = 'Culligan.Protocol.V2.Device.Gbfc';
exports.AlarmMessage = Alarm.createD2CMessage(exports.NAMESPACE, gbfc_1.Gbfc.alarms.firmwareBased).annotations({
    identifier: `${exports.NAMESPACE}.AlarmMessage`,
});
exports.EventMessage = Event.createD2CMessage(exports.NAMESPACE, gbfc_1.Gbfc.events).annotations({
    identifier: `${exports.NAMESPACE}.EventMessage`,
});
exports.StateMessage = State.createD2CMessage(gbfc_1.Gbfc.State).annotations({
    identifier: `${exports.NAMESPACE}.StateMessage`,
});
exports.StateC2DMessage = State.createC2DMessage(gbfc_1.Gbfc.State).annotations({
    identifier: `${exports.NAMESPACE}.StateC2DMessage`,
});
exports.SystemC2DMessage = System.C2DMessage.annotations({
    identifier: `${exports.NAMESPACE}.SystemC2DMessage`,
});
exports.TelemetryMessage = Telemetry.createD2CMessage(gbfc_1.Gbfc.Telemetry).annotations({
    identifier: `${exports.NAMESPACE}.TelemetryMessage`,
});
exports.TelemetryC2DMessage = Telemetry.C2DMessage.annotations({
    identifier: `${exports.NAMESPACE}.TelemetryC2DMessage`,
});
exports.ConsumableD2CMessage = Consumable.createD2CMessage(exports.NAMESPACE, gbfc_1.Gbfc.slots);
exports.ConsumableC2DMessage = Consumable.createC2DMessage(exports.NAMESPACE, gbfc_1.Gbfc.slots, gbfc_1.Gbfc.Catalogue);
exports.PrefsD2CMessage = Prefs.createD2CMessage(exports.NAMESPACE, gbfc_1.Gbfc.Prefs);
exports.PrefsC2DMessage = Prefs.createC2DMessage(exports.NAMESPACE, gbfc_1.Gbfc.SettablePrefs);
exports.D2CMessage = effect_1.Schema.Union(exports.AlarmMessage, exports.ConsumableD2CMessage, exports.EventMessage, exports.StateMessage, exports.TelemetryMessage, exports.PrefsD2CMessage).annotations({
    identifier: `${exports.NAMESPACE}.D2CMessage`,
});
exports.C2DMessage = effect_1.Schema.Union(exports.ConsumableC2DMessage, exports.StateC2DMessage, exports.SystemC2DMessage, exports.TelemetryC2DMessage, exports.PrefsC2DMessage).annotations({
    identifier: `${exports.NAMESPACE}.C2DMessage`,
});
exports.DeviceToCloud = common_1.Payload.create(2, gbfc_1.Gbfc, exports.D2CMessage, {
    title: `${gbfc_1.Gbfc.label} — Device to Cloud Protocol`,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceToCloud`,
    title: `${gbfc_1.Gbfc.label} — Device to Cloud Protocol`,
});
exports.CloudToDeviceEnvelope = common_1.Payload.create(2, gbfc_1.Gbfc, exports.C2DMessage, {
    title: `${gbfc_1.Gbfc.label} — Cloud to Device Envelope`,
}).annotations({
    identifier: `${exports.NAMESPACE}.CloudToDeviceEnvelope`,
    title: `${gbfc_1.Gbfc.label} — Cloud to Device Envelope`,
});
exports.CloudToDevice = common_1.Payload.createCloudToDevice(2, gbfc_1.Gbfc, exports.C2DMessage, gbfc_1.Gbfc.SettablePrefs, {
    title: `${gbfc_1.Gbfc.label} — Cloud to Device Protocol`,
}).annotations({
    identifier: `${exports.NAMESPACE}.CloudToDevice`,
    title: `${gbfc_1.Gbfc.label} — Cloud to Device Protocol`,
});
//# sourceMappingURL=gbfc.js.map